<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-7/12 lg:w-7/12 w-full mb-6">
                <vs-alert :active="!this.travelOrderValid" class="mt-5 mb-6" icon-pack="feather" icon="icon-alert-circle" color="danger">
                    {{$t("TravelOrderInvalid")}}
                </vs-alert>
                <vx-card :title='$t("Transport")'>
                    <vs-table v-model="selected" @selected="handleSelected" :data="transports">

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                            <div class="flex flex-wrap-reverse items-center mb-3">
                                <vs-button v-if="$checkPermission(1201)" type="border" color="success" icon-pack="feather" icon="icon-eye" @click="openTravelOrder" class="mr-3 mb-3">{{$t("OpenTravelOrder")}}</vs-button>
                                <vs-button v-if="$checkPermission(1202)" type="border" color="success" icon-pack="feather" icon="icon-refresh-cw" @click="regenerateTravelOrder" class="mr-3 mb-3">{{$t("RegenerateTravelOrder")}}</vs-button>
                                <vs-button v-if="$checkPermission(1202)" type="border" :disabled="!transportEdit || selected.id === transports[transports.length-1].id" color="success" icon-pack="feather" icon="icon-copy" @click="duplicateSelected" class="mr-3 mb-3">{{$t("DuplicateSelectedTransport")}}</vs-button>
                            </div>

                        </div>

                        <template slot="thead">
                            <vs-th>{{$t("StartPoint")}}</vs-th>
                            <vs-th>{{$t("Destination")}}</vs-th>
                            <vs-th>{{$t("Kilometers")}}</vs-th>
                            <vs-th>{{$t("TotalTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                                <vs-td :data="data[indextr].start_short">
                                    {{data[indextr].start_short}}
                                </vs-td>
                                <vs-td :data="data[indextr].destination_short">
                                    {{data[indextr].destination_short}}
                                </vs-td>
                                <vs-td :data="data[indextr].end_kilometers - data[indextr].start_kilometers">
                                    {{data[indextr].end_kilometers - data[indextr].start_kilometers}}
                                </vs-td>
                                <vs-td :data="data[indextr].total_time">
                                    {{data[indextr].total_time}}
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
            <div class="vx-col xl:w-5/12 lg:w-5/12 w-full">
                <vx-card :title="$t('Edit')" v-if="transportEdit">

                    <p class="mt-6">{{$t("StartTime")}}</p>
                    <flat-pickr v-if="$checkPermission(1202)" class="w-full" :config="configDateTimePicker" v-model="transportEdit['start_time']"/>
                    <vs-input v-else-if="timesParsed" :disabled="true" v-model="timesParsed['start']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("EndTime")}}</p>
                    <flat-pickr v-if="$checkPermission(1202)" class="w-full" :config="configDateTimePicker" v-model="transportEdit['end_time']"/>
                    <vs-input v-else-if="timesParsed" :disabled="true" v-model="timesParsed['end']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("StartPoint")}}</p>
                    <vs-input :disabled="!$checkPermission(1202)" v-model="transportEdit['start_short']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("StartPoint")}} - {{$t("Address")}}</p>
                    <vs-input :disabled="!$checkPermission(1202)" v-model="transportEdit['start_point']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("Destination")}}</p>
                    <vs-input :disabled="!$checkPermission(1202)" v-model="transportEdit['destination_short']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("Destination")}} - {{$t("Address")}}</p>
                    <vs-input :disabled="!$checkPermission(1202)" v-model="transportEdit['destination']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("StartKilometers")}}</p>
                    <vs-input :disabled="(transportEdit['start_is_home'] && !fullEditUnlocked) || !$checkPermission(1202)" v-model="transportEdit['start_kilometers']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("EndKilometers")}}</p>
                    <vs-input :disabled="transportEdit['destination_is_home'] && !fullEditUnlocked  || !$checkPermission(1202)" v-model="transportEdit['end_kilometers']" style="width: 100%"></vs-input>
                    <p class="mt-6">{{$t("Passengers")}}</p>
                    <vs-select :disabled="!$checkPermission(1202)" v-if="transportEditUsers" autocomplete multiple class="selectExample w-full" v-model="transportEditUsers">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                    </vs-select>
                    <p class="mt-6">{{$t("TransportType")}}</p>
                    <vs-select :disabled="!$checkPermission(1202)" autocomplete class="selectExample w-full" v-model="transportEdit['transport_type_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in transportTypes" />
                    </vs-select>
                    <p class="mt-6">{{$t("Comments")}}</p>
                    <vs-textarea :disabled="!$checkPermission(1202)" v-model="transportEdit['comment']" class="w-full" />

                    <vs-button v-if="$checkPermission(1202)" :disabled="!selectedTransportValid" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="saveTransport">{{$t("Save")}}</vs-button>
                    <vs-button v-if="$checkPermission(1202) && fullEditUnlocked" style="float: left" color="warning" icon-pack="feather" icon="icon-unlock" type="border" class="mt-6; ml-3" @click="fullEditUnlocked = false"/>
                    <vs-button v-if="$checkPermission(1202) && !fullEditUnlocked" style="float: left" color="warning" icon-pack="feather" icon="icon-lock" type="border" class="mt-6; ml-3" @click="fullEditUnlocked = true"/>
                    <vs-button v-if="$checkPermission(1202)" :disabled="selected.id === transports[transports.length-1].id || selected.id === transports[0].id || !fullEditUnlocked" style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeTransport">{{$t("Delete")}}</vs-button>

                    <div style="clear: both"></div>
                </vx-card>
            </div>

        </div>
    </div>

</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        data(){
            return {
                transports: [],
                selected: {},

                fullEditUnlocked: false,

                transportEdit: null,
                transportEditUsers: null,

                transportTypes: null,

                timesParsed: null,

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        computed:{
            travelOrderValid() {

                if(this.transports.length === 0) return true;

                if(this.moment(this.transports[0].end_time).isBefore(this.moment(this.transports[0].start_time))) return false;

                for(let x = 1; x < this.transports.length; x++) {

                    if(this.transports[x-1].end_kilometers !== this.transports[x].start_kilometers) return false;
                    if(this.moment(this.transports[x].start_time).isBefore(this.moment(this.transports[x-1].end_time))) return false;
                    if(this.moment(this.transports[x].end_time).isBefore(this.moment(this.transports[x].start_time))) return false;
                    if(this.transports[x-1].destination !== this.transports[x].start_point) return false;
                    if(this.transports[x-1].destination_short !== this.transports[x].start_short) return false;

                }

                return true;
            },
            selectedTransportValid() {

                if(Number(this.transportEdit['end_kilometers']) < Number(this.transportEdit['start_kilometers'])) return false;
                if(this.moment(this.transportEdit['end_time']).isBefore(this.moment(this.transportEdit['start_time']))) return false;
                if(this.transportEdit['start_point'].length === 0 || this.transportEdit['start_short'].length === 0 || this.transportEdit['destination'].length === 0 || this.transportEdit['destination_short'].length === 0) return false;

                return true;
            }
        },
        methods:{
            handleSelected(tr){

                const thisIns = this;
                this.$http.get('/api/v1/transport/list/all/' + tr.id)
                    .then(function (response) {
                        thisIns.transportEdit = response.data;
                        thisIns.timesParsed = {
                            start: thisIns.moment(thisIns.transportEdit['start_time']).format('DD/MM/YYYY HH:mm'),
                            end: thisIns.moment(thisIns.transportEdit['end_time']).format('DD/MM/YYYY HH:mm')
                        }
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

                this.$http.get('/api/v1/transport/list/all/' + tr.id + "/users")
                    .then(function (response) {
                        thisIns.transportEditUsers = response.data;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            updateTravelOrder(){
                const thisIns = this;
                this.$http.get('/api/v1/travel_order/order/' + this.$route.params.id + "/transports")
                    .then(function (response) {
                    thisIns.transports = response.data;
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveTransport(){
                const thisIns = this;
                this.$http.put('/api/v1/transport/list/all/' + this.selected.id, {
                    transport: {
                        start_time: this.moment(thisIns.transportEdit['start_time']).format(),
                        end_time: this.moment(thisIns.transportEdit['end_time']).format(),
                        start_point: thisIns.transportEdit['start_point'],
                        start_short: thisIns.transportEdit['start_short'],
                        destination: thisIns.transportEdit['destination'],
                        destination_short: thisIns.transportEdit['destination_short'],
                        start_kilometers: Number(thisIns.transportEdit['start_kilometers']),
                        end_kilometers: Number(thisIns.transportEdit['end_kilometers']),
                        transport_type_id: Number(thisIns.transportEdit['transport_type_id']),
                        comment: thisIns.transportEdit['comment'],
                    },
                    users: thisIns.transportEditUsers,
                }).then(function () {
                        thisIns.updateTravelOrder();
                        thisIns.selected = {};
                        thisIns.transportEdit = null;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeTransport(){
                const thisIns = this;
                this.$http.delete('/api/v1/transport/list/all/' + this.selected.id)
                    .then(function () {
                        thisIns.updateTravelOrder();
                        thisIns.selected = {};
                        thisIns.transportEdit = null;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            duplicateSelected(){
                const thisIns = this;
                this.$http.get('/api/v1/transport/list/all/' + this.selected.id + "/duplicate")
                    .then(function (response) {
                        thisIns.updateTravelOrder();
                        thisIns.selected = {};
                        thisIns.transportEdit = null;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            openTravelOrder(){
                const thisIns = this;
                this.$http.get('/api/v1/travel_order/order/' + this.$route.params.id + "/pdf").then(function (response) {

                    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                        window.location.href = "/pdf/travel_order/" + response.data;
                    }else{
                        window.open("/pdf/travel_order/" + response.data, "_blank");
                    }
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            regenerateTravelOrder(){
                const thisIns = this;
                this.$http.get('/api/v1/travel_order/regenerate/' + this.$route.params.id).then(function (response) {
                    thisIns.$vs.notify({
                        title:'Success',
                        text: "Created",
                        color:'success',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }

        },
        created() {
            this.updateTravelOrder();
            const thisIns = this;
            this.$http.get('/api/v1/transport_type/')
                .then(function (response) {
                    thisIns.transportTypes = response.data
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
        }
    }
</script>
